/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
export default {
	pullOrder({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/MarketPalce/pull/orders/" + item.companyInfoId, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("ORDER_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("ORDER_LIST", []);
				}
				resolve(err.response);
			});
		});
	},
	listOrder({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						axios.get(sistemAddress + "api/uzumservice/Company/list/company", {
							headers: {
								Authorization: `Bearer ${token}`,
								token: token
							}
						}).then(response => {
							if (response.status == 200) {
								item = JSON.parse(response.data.json);
								commit("CUSTOMER_LIST", item);
								resolve(response.data);
							} else if (response.status == 401) {
								router.push("/login")
							}
						}).catch(err => {
							if (err.response.status == 401) {
								router.push("/login")
							} else if (err.response.status == 400) {
								commit("CUSTOMER_LIST", []);
							}
							resolve(err.response);
						});
					}
				});
			} catch (error) {

			}

	},
	listOrderProduct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.post(sistemAddress + "api/uzumservice/MarketPalce/list/orders/getproduct", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
						//	commit("ORDER_PRODUCT", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
						//	commit("ORDER_PRODUCT", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listMarketplaceName({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/MarketPalce/mpnamelist", {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = response.data;
							commit("MPNAME_LIST", item);
							resolve(response);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("MPNAME_LIST", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	sendOrderToArchive({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.post(sistemAddress + "api/uzumservice/MarketPalce/send/e-archive", item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				console.log(response)
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {

				}
				resolve(err.response);
			});
		});
	},
}
